import React, { useState } from 'react';
import { Formik } from 'formik';
import { gql, useQuery, useMutation } from '@apollo/client';

import { BoxContainer, BoxItemTitle } from '../../../components';

import { RequiredFieldsForm } from '../../requiredFields/components';
import { useNormalizeRequiredFields } from '../../requiredFields/hooks';
import { useActiveAccount } from '../../../shared/activeAccount';

export const GET_POLICY_REQUIRED_VEHICLE_FIELDS = gql`
  query GetPolicyRequiredVehicleFields($id: ID!) {
    policy(id: $id) {
      id
      requiredVehicleFields
    }
  }
`;

const UPDATE_POLICY_REQUIRED_VEHICLE_FIELDS = gql`
  mutation updatePolicyRequiredVehicleFields($policyId: ID!, $requiredVehicleFields: [String]!) {
    updatePolicyRequiredVehicleFields(policyId: $policyId, requiredVehicleFields: $requiredVehicleFields) {
      id
      requiredVehicleFields
    }
  }
`;

export default function VehicleRequiredFields({
  policyId,
  requireStateOfRegistration,
  roleBelowCollaborator,
  typeBelowBroker,
  onError = () => {}
}) {
  const {
    roleIsAtLeast,
    ROLES: { COLLABORATOR }
  } = useActiveAccount();
  const [success, setSuccess] = useState(false);

  const { data, loading, error } = useQuery(GET_POLICY_REQUIRED_VEHICLE_FIELDS, {
    variables: { id: policyId }
  });

  const [update, { loading: updating, error: updateError }] = useMutation(UPDATE_POLICY_REQUIRED_VEHICLE_FIELDS, {
    onCompleted: () => {
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    },
    onError,
    refetchQueries: [
      {
        query: GET_POLICY_REQUIRED_VEHICLE_FIELDS,
        variables: { id: policyId }
      }
    ]
  });

  const normalizedVehicleFields = useNormalizeRequiredFields({
    fields: data?.policy?.requiredVehicleFields,
    requireStateOfRegistration
  });

  const initialValues = {
    requiredFields: normalizedVehicleFields
  };

  const handleSubmit = values => {
    update({
      variables: {
        policyId,
        requiredVehicleFields: values?.requiredFields
          ?.filter(field => field.required || field.alwaysRequired)
          ?.map(field => field.name)
      }
    });
  };

  return (
    <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
      {formik => (
        <BoxContainer className="p-3 mb-4">
          <BoxItemTitle
            title="Create Vehicle"
            subtitle="If enabled, these fields will be required to create a new Vehicle."
          />
          <RequiredFieldsForm
            formik={formik}
            loading={loading}
            updating={updating}
            error={error || updateError}
            success={success}
            showSubmitButton={roleIsAtLeast(COLLABORATOR)}
            disableAllFields={roleBelowCollaborator || typeBelowBroker}
          />
        </BoxContainer>
      )}
    </Formik>
  );
}
